export default function FAQ() {
  const faqs = [
    { question: 'Setup é aberto?', answer: 'Sim' },
    { question: 'Pit stop é obrigatório?', answer: 'Não' },
    { question: 'Consumo é real?', answer: 'Sim' },
    { question: 'Danos são totais?', answer: 'Sim' },
    { question: 'Quais assistências são permitidas?', answer: 'TC e ABS' },
    { question: 'Como funcionam penalidades?', answer: 'Simulador + protesto' },
    { question: 'Onde vejo pontuação e traçados?', answer: 'No regulamento do grupo' },
    { question: 'Como envio comprovante?', answer: 'No formulário de inscrição' },
    { question: 'Tem reembolso?', answer: 'Não' }
  ];

  return (
    <section id="faq" className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            Perguntas Frequentes
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Respostas rápidas para as dúvidas mais comuns sobre o campeonato.
          </p>
        </div>

        {/* FAQ Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-gray-50 p-6 rounded-xl border-2 border-gray-200 hover:border-orange-500 transition-all duration-300"
            >
              <div className="flex items-start mb-3">
                <i className="ri-question-line text-orange-500 text-2xl mr-3 mt-1 flex-shrink-0"></i>
                <h3 className="text-base sm:text-lg font-bold text-gray-900">{faq.question}</h3>
              </div>
              <div className="flex items-start ml-11">
                <p className="text-base sm:text-lg text-gray-700 font-semibold">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Final */}
        <div className="mt-16 text-center">
          <p className="text-lg text-gray-600 mb-6">
            Ainda tem dúvidas? Entre no grupo oficial para mais informações.
          </p>
          <a 
            href="https://chat.whatsapp.com/B8pgKs2dDmD57QLiP896ds"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-8 py-3 bg-gray-900 hover:bg-gray-800 text-white font-semibold rounded-lg transition-all duration-300 text-base whitespace-nowrap cursor-pointer"
          >
            Entrar no grupo oficial
          </a>
        </div>
      </div>
    </section>
  );
}
